import { useEffect, useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { LoadingState, ErrorState } from "@/components/LoadingError";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { apiFetch } from "@/utils/api";

export function AdminMaintenancePage() {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    apiFetch<{ maintenanceMode: boolean; maintenanceMessage: string }>("/admin/maintenance")
      .then((d) => {
        setMaintenanceMode(d.maintenanceMode);
        setMaintenanceMessage(d.maintenanceMessage ?? "");
      })
      .catch((e) => setError(e instanceof Error ? e.message : "Failed to load"))
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaved(false);
    await apiFetch("/admin/maintenance", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ maintenanceMode, maintenanceMessage }),
    });
    setSaved(true);
  };

  if (loading) return <LoadingState />;
  if (error) return <ErrorState message={error} />;

  return (
    <div className="space-y-4">
      <PageHeader
        title="Maintenance Mode"
        subtitle="When enabled, regular users see a maintenance page. Admins with Maintenance permission and platform admins can still access the app to turn it off."
      />
      <div className="bg-white rounded-lg shadow p-6 space-y-4 max-w-lg">
        <div className="flex items-center justify-between">
          <Label htmlFor="maint">Maintenance Mode</Label>
          <Switch
            id="maint"
            checked={maintenanceMode}
            onCheckedChange={setMaintenanceMode}
          />
        </div>
        <div className="space-y-1.5">
          <Label>Message</Label>
          <Textarea
            value={maintenanceMessage}
            onChange={(e) => setMaintenanceMessage(e.target.value)}
            placeholder="InFloTrack is temporarily unavailable for maintenance."
            rows={3}
          />
        </div>
        <Button onClick={save} className="bg-[#1e3a4f] hover:bg-[#163041]">Save</Button>
        {saved && <p className="text-sm text-green-700">Settings saved.</p>}
      </div>
    </div>
  );
}
